import React, { useRef, useState } from "react";
import { useDropzone } from "react-dropzone";

import Button from "../components/Button/Button";
import InputTextSlide from "../components/InputTextSlide/InputTextSlide";
import LabelSelect from "../components/LabelSelect/LabelSelect";
import Header from "../elements/Header/Header";
import Loading from "../elements/LoadingScreen/Loading";
import { footer1, footer2 } from "./footers";
import {
  copySignatureToClipboard,
  createPhoneNum,
  FOOTER_DROPZONE_ACCEPT,
  FOOTER_INITIAL_FORM,
  handleFooterDrop,
  submitFooterImage,
} from "./footerGeneratorController";
import "../Slideshow/Slideshow.css";
import "./footerGenerator.css";

const FooterGenerator = () => {
  const [choosenFooter, setChoosenFooter] = useState(2);
  const [formData, setFormData] = useState(FOOTER_INITIAL_FORM);
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState({});
  const [message, setMessage] = useState("");
  const [imageMessage, setImageMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const iframeRef = useRef(null);

  const onDrop = (acceptedFiles) => {
    handleFooterDrop({
      acceptedFile: acceptedFiles,
      setFile,
      setPreview: setFilePreview,
      setImageInfo: setImageMessage,
    });
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
    accept: FOOTER_DROPZONE_ACCEPT,
  });

  const handleChange = (event) => {
    setFormData((previous) => ({
      ...previous,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = async () => {
    await submitFooterImage({
      file,
      setLoading,
      setMessage,
      setImageInfo: setImageMessage,
    });
  };

  return (
    <>
      <Header />
      {loading && <Loading info={"Prosze czekac, zdjecie jest wgrywane..."} />}
      <div className="slideshow footer-generator">
        <form className="slideshow__form-wrapper footer-generator__form">
          <div className="slideshow-flex-row footer-generator__intro-row">
            <InputTextSlide
              placeholder="Imie i nazwisko"
              value={formData.name}
              text="Imie i nazwisko: "
              name="name"
              handleChange={handleChange}
            />

            <InputTextSlide
              placeholder="Stanowisko"
              value={formData.job}
              text="Stanowisko: "
              name="job"
              handleChange={handleChange}
            />
          </div>

          <div className="slideshow-flex-row footer-generator__intro-row">
            <InputTextSlide
              placeholder="Numer telefonu"
              value={formData.phone}
              max={9}
              onlyNum={true}
              text="Numer telefonu: "
              name="phone"
              handleChange={handleChange}
            />

            <InputTextSlide
              placeholder="Pelny mail"
              value={formData.mail}
              text="Pelny mail: "
              name="mail"
              handleChange={handleChange}
            />
          </div>

          <div className="slideshow-flex-row footer-generator__upload-row">
            <div {...getRootProps()} className="footer-generator__dropzone">
              <input {...getInputProps()} />
              <p>Przeciagnij i upusc zdjecie lub kliknij i wybierz</p>
              {file && (
                <img
                  src={filePreview}
                  alt={file.name}
                  className="footer-generator__preview"
                />
              )}
            </div>

            <div className="footer-generator__actions">
              <Button
                txt="Wyslij zdjecie"
                click={handleSubmit}
                styles={{
                  cursor: "pointer",
                  margin: "20px 20px",
                }}
              />
              <Button
                txt="Skopiuj stopke"
                click={() => copySignatureToClipboard(iframeRef)}
                styles={{
                  backgroundColor: "black",
                  cursor: "pointer",
                  margin: "20px 20px",
                }}
              />
            </div>
          </div>

          <div className="footer-generator__select-wrap">
            <LabelSelect
              options={[
                { value: 2, txt: "Nowa" },
                { value: 1, txt: "Stara" },
              ]}
              placeholder={false}
              text="Wybierz stopke: "
              name="footer"
              handleChange={(event) => setChoosenFooter(Number(event.target.value))}
            />
          </div>
          <h3 className="footer-generator__image-message">{imageMessage}</h3>

          <iframe
            title="Podglad stopki"
            width="700"
            className="footer-generator__iframe"
            ref={iframeRef}
            height={250}
            srcDoc={
              choosenFooter === 1
                ? footer1(formData, message, createPhoneNum)
                : footer2(formData, message, createPhoneNum)
            }
          ></iframe>
        </form>
      </div>
    </>
  );
};

export default FooterGenerator;
